export default __webpack_public_path__ + "static/media/dropdownArrow.41bfd1c9.svg";